export type StorageKeys = 'FOO' | 'BAR'; // todo : remove thease temporary keys
export const SYNC_IN_PROGRESS = 'sync-in-progress';


export const PIN_KEY = 'USER_PIN_KEY'
export const USER_PIN_AUTHENTICATED = 'USER_PIN_AUTHENTICATED_KEY'

export const GEOCODE_FAILED_VISIT = 'GEOCODE_FAILED_VISIT'
export const CONTACTS_FAILED_VISIT = 'CONTACTS_FAILED_VISIT'
export const SELECTED_LANGUAGE_KEY = 'SELECTED_LANGUAGE_KEY';
